import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initializeTheme } from './lib/theme';
import './styles.css';

initializeTheme();
const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Missing #root element');
createRoot(rootElement).render(<App />);
